import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { sessionGetItemStr, sessionSetItemStr } from '../../../utils/sessionHelpers'
import pathname from '../../../constants/pathname'

export default function InfoReportsAudit({
  schema,
  showButton = false,
  auditorRole = false,
  comments = null,
}) {
  const [formSchema, setFormSchema] = useState(schema)

  const handleClickLinked = () => {
    sessionSetItemStr('projectId', formSchema?.id || '')

    const xurl = `${process.env.REACT_APP_SERVER_URL}${pathname.proposal.overview.overviewCoworker}`

    const link = document.createElement('a')
    link.target = '_blank'
    link.rel = 'opener'
    link.href = xurl
    link.setAttribute('visibility', 'hidden')
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  return (
    <>
      {showButton ? (
        <>
          <Row style={{ marginTop: 10, textAlign: 'right' }}>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
              disabled={!formSchema?.id}
              onClick={(e) => {
                handleClickLinked()
              }}
            >
              {'ดูข้อมูลโครงการเพิ่มเติม'}
            </IconButton>
          </Row>
        </>
      ) : (
        <>
          <Panel
            bordered
            style={{
              backgroundColor: '#cccbca4d',
              border: '1px solid #4e4b488c',
            }}
          >
            <Row>
              <Col lg={12} md={12} sm={24} xs={24}>
                <b>{formSchema?.projectCodeLabel || ''}</b> {formSchema?.projectCode || ''}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24}>
                <b>{formSchema?.contractNoLabel || ''}</b> {formSchema?.contractNo || ''}
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={24} xs={24}>
                <b>{formSchema?.projectNameLabel || ''} </b> {formSchema?.projectName || ''}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24}>
                <b>{formSchema?.coordinatorLabel || ''} </b> {formSchema?.coordinator || ''}
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={24} xs={24}>
                <b>{formSchema?.projectStatusLabel || ''}</b> {formSchema?.projectStatus || ''}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24}>
                <b>{formSchema?.responsiblerLabel || ''}</b> {formSchema?.responsibler || ''}
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={24} xs={24}>
                <b>{formSchema?.granteeOrganizationLabel || ''}</b>{' '}
                {formSchema?.granteeOrganization || ''}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24}></Col>
            </Row>
            {!auditorRole && (
              <Row style={{ marginTop: 10, textAlign: 'right' }}>
                <IconButton
                  appearance="ghost"
                  icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                  disabled={!formSchema?.id}
                  onClick={(e) => {
                    handleClickLinked()
                  }}
                >
                  {'ดูข้อมูลเพิ่มเติม'}
                </IconButton>
              </Row>
            )}
          </Panel>
        </>
      )}
    </>
  )
}
